import React, { Component } from 'react';
import { Modal, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import Countdown from 'react-countdown-now';
import messages from './messages';

type Props = {
  dismiss: Function,
  extendSession: Function,
  userIdle: Function,
  logOut: Function,
  showExtendUserSessionModal: boolean,
  modalTimestamp: ?number,
  intl: any,
};

type CountdownProps = {
  minutes: number,
  seconds: number,
  completed: boolean,
  intl: Object,
  dismiss: Function,
  extendSession: Function,
  userIdle: Function,
  logOut: Function,
  showExtendUserSessionModal: boolean,
  modalTimestamp: ?number,
};

class ExtendSessionModal extends Component<Props, CountdownProps> {
  canExtendSession = (): boolean => {
    const { modalTimestamp } = this.props;
    if (!modalTimestamp) return false;
    const minutes = Number(
      import.meta.env.REACT_APP_IDLE_SESSION_EXTEND_WINDOW_MINUTES ?? '1',
    );
    const timeSinceModalShown = Date.now() - modalTimestamp;
    return timeSinceModalShown < minutes * 60 * 1000;
  };

  renderModal = ({
    minutes,
    seconds,
    completed,
    intl,
    showExtendUserSessionModal,
    dismiss,
    extendSession,
    logOut,
  }: CountdownProps) => {
    const canExtend = this.canExtendSession();
    const handleContinue = () => {
      if (canExtend) {
        extendSession();
      } else {
        // After 30 minutes, user must acknowledge logout
        logOut();
      }
    };

    return (
      <div className="static-modal">
        <Modal
          id="extendSessionModal"
          bsSize="small"
          dialogClassName="modal-dialog modal-alert"
          show={showExtendUserSessionModal}
          onHide={dismiss}
          backdrop="static" // Prevent closing by clicking outside
          keyboard={false} // Prevent closing with ESC key
          autoFocus={false}
        >
          <Modal.Body>
            <Row>
              <div>
                <h1 className="fortress-logo-gray timeout-logo"> </h1>
              </div>
              <Row>
                <Col xs={12} className="padbottom15">
                  <h2 className="text-center">
                    {intl.formatMessage(messages.headsUp)}
                  </h2>
                </Col>
                <Col xs={12}>
                  <h4 className="text-center">
                    {/* <FormattedMessage {...messages.details} /> */}
                    {intl.formatMessage(messages.details)}
                  </h4>
                </Col>
              </Row>
            </Row>
            <div
              className="alert alert-danger padright30 padleft30 timeoutwrapper timeout-remaining"
              style={{ textAlign: 'center' }}
              id="countDown"
            >
              {minutes}:{seconds}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Row>
              <Col xs={12}>
                <p className="text-center">
                  {/* <FormattedMessage {...messages.instructions} /> */}
                  {intl.formatMessage(messages.instructions)}
                </p>
              </Col>
            </Row>
            <ButtonToolbar>
              <Col xs={canExtend ? 6 : 12}>
                <Button
                  type="button"
                  bsStyle={canExtend ? 'primary' : 'default'}
                  onClick={handleContinue}
                >
                  {canExtend
                    ? intl.formatMessage(messages.continue)
                    : intl.formatMessage(messages.acknowledgeLogout)}
                </Button>
              </Col>
              {canExtend && (
                <Col xs={6}>
                  <Button type="button" bsStyle="default" onClick={logOut}>
                    {intl.formatMessage(messages.signOut)}
                  </Button>
                </Col>
              )}
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  render() {
    const { modalTimestamp } = this.props;
    const minutes = Number(
      import.meta.env.REACT_APP_IDLE_SESSION_EXTEND_WINDOW_MINUTES ?? '1',
    );
    const countdownDate = modalTimestamp
      ? modalTimestamp + minutes * 60 * 1000
      : Date.now() + minutes * 60 * 1000;

    return (
      <Countdown
        date={countdownDate}
        renderer={this.renderModal}
        {...this.props}
      />
    );
  }
}

export default ExtendSessionModal;
